import React, { useEffect, useContext, useState } from 'react'
import { sherlockCheck } from '@api/massProcessing'
import {
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
} from '@material-ui/core'

import {
  actions
} from '../listView.reducer'
import { ListViewDispatchContext, ListViewStateContext } from '../listView.context'

import CircularProgress from '@material-ui/core/CircularProgress'

import { massProcessingApi } from '@atheneum/api'

export const SherlockIgnoreModal = () => {
  const state = useContext(ListViewStateContext)
  const dispatch = useContext(ListViewDispatchContext)
  const [sherlockRules, setSherlockRules] = useState([])
  const loadingSherlockRule = !sherlockRules.length

  useEffect(() => {
    if (state.ignoreRule) {
      ; (async () => {
        const res = await massProcessingApi.sherlockCheck(state.ignoreRule.action.listItemId)
        setSherlockRules(
          res.results
            .filter(rule => !rule.allowed)
            .map(r => ({
              ...r.reason,
              display_reason: r.display_reason,
              checked: true
            }))
        )
      })()
    }
    return () => setSherlockRules([])
  }, [state.ignoreRule])

  return (
    <Dialog open={!!state.ignoreRule}>
      <DialogTitle>Ignore sherlock rules</DialogTitle>
      <DialogContent>
        <div>
          <div>Select rules to be ignored:</div>
          {!sherlockRules.length && (<div>Loading sherlock rules...</div>)}
          {sherlockRules.map(r => {
            return (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  minWidth: 500
                }}>
                <input
                  style={{
                    flexGrow: 0
                  }}
                  autoComplete="off"
                  onChange={() =>
                    setSherlockRules(
                      sherlockRules.map(rule =>
                        rule.id === r.id ? { ...r, checked: !r.checked } : rule
                      )
                    )
                  }
                  type="checkbox"
                  checked={r.checked}
                />

                <span key={r.id}>
                  <strong>{r.value} </strong>
                  {r.type}
                </span>
              </div>
            )
          })}
        </div>
        <TextField
          value={state.ignoreRuleReason}
          fullWidth
          onChange={e =>
            dispatch({
              type: actions.IGNORE_RULE_REASON,
              payload: e.target.value
            })
          }
        />
        <div
          style={{
            display: 'flex',
            marginTop: '30px',
            justifyContent: 'flex-end'
          }}>
          <Button
            className={`mp-send-email-action-button-next`}
            disabled={state.ruleIgnoreSending || !state.ignoreRuleReason}
            onClick={async () => {
              dispatch({type: actions.SET_RULE_IGNORE_SENDNIG, payload: true})
              await massProcessingApi.ignoreRule(
                state.ignoreRule,
                state.ignoreRuleReason,
                sherlockRules.filter(r => r.checked)
              )
              dispatch({ type: actions.SET_RULE_IGNORE_SENDNIG, payload: false })
              dispatch({ type: actions.IGNORE_RULE_DONE })
            }}>
            {state.ruleIgnoreSending || loadingSherlockRule ? (
              <CircularProgress
                style={{ height: '15px', width: '15px', color: '#fff' }}
              />
            ) : (
              'Ok'
            )}
          </Button>
          <Button
            disabled={state.loadingSherlockRule}
            className={`mp-send-email-action-button-cancel`}
            onClick={() => dispatch({ type: actions.IGNORE_RULE_CANCEL })}>
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
